import { useContext } from 'react';
import { SearchResultContext } from '../contexts';
function useSearchBreadcrumbs() {
    const searchResult = useContext(SearchResultContext);
    if (!searchResult)
        return [];
    const results = [
        {
            linkType: 'category',
            linkId: searchResult.category.id,
            title: searchResult.category.title,
        },
    ];
    if (searchResult.category.parentCategory) {
        results.unshift({
            linkType: 'category',
            linkId: searchResult.category.parentCategory.id,
            title: searchResult.category.parentCategory.title,
        });
    }
    return results;
}
export default useSearchBreadcrumbs;
//# sourceMappingURL=useSearchBreadcrumbs.js.map